import React from 'react';
import { Input } from '../ui/Input';
import { ToggleSwitch } from './ToggleSwitch';
import type { StepProps } from '../../types/careers';
export function StepYou({
  form,
  errors,
  onChange
}: StepProps) {
  return <div className="space-y-6" data-id="element-85" data-mp="2f3n75c2vc56c">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-86" data-mp="2f3dh5ohtpy0n">
        <Input label="First name" name="firstName" placeholder="Jane" autoComplete="given-name" value={form.firstName} error={errors.firstName} onChange={e => onChange('firstName', e.target.value)} data-id="element-87" data-mp="2jwgco265vhjh" />
        <Input label="Last name" name="lastName" placeholder="Smith" autoComplete="family-name" value={form.lastName} error={errors.lastName} onChange={e => onChange('lastName', e.target.value)} data-id="element-88" data-mp="2xumr1yviaosr" />
      </div>

      <Input label="Email" name="email" type="email" inputMode="email" placeholder="jane@example.com" autoComplete="email" value={form.email} error={errors.email} onChange={e => onChange('email', e.target.value)} data-id="element-89" data-mp="18fyf1yqtv8v9" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:items-end" data-id="element-90" data-mp="15d59ywpghquz">
        <Input label="Phone" name="phone" type="tel" inputMode="tel" placeholder="+1 (555) 000-0000" autoComplete="tel" value={form.phone} error={errors.phone} onChange={e => onChange('phone', e.target.value)} data-id="element-91" data-mp="15b2kcds7tzqs" />
        <ToggleSwitch label="OK to text" description="We move fast and text is fastest." checked={form.okToText} onChange={checked => onChange('okToText', checked)} data-id="element-92" data-mp="1t0wrqftrmw3n" />
      </div>
    </div>;
}